<template>
  <div class="modal-card" style="width: 100%">
    <header class="modal-card-head">
      <p class="modal-card-title">Required Date</p>
      <button
        type="button"
        class="delete"
        aria-label="close"
        @click="cancel"
      ></button>
    </header>

    <section class="modal-card-body body-content">
      <div class="content">
        <p>Please choose a date below that this record needs to leave the status of {{ status.label }}.</p>
      </div>

      <form-field-datetime-picker
        v-model="datetime"
        is-inline
      ></form-field-datetime-picker>

      <div v-if="nextAppointment || nextTask" class="mt-50">
        <div class="content">
          <p>Or use either the next appointment or scheduled contact time below:</p>
        </div>

        <div v-if="nextAppointment" class="use-time-line">
          <strong>Next Appointment:</strong> {{ nextAppointment }}
          <b-button
            type="is-primary"
            size="is-small"
            outlined
            @click="setTimeToThis(nextAppointment)"
          >Use
          </b-button>
        </div>
        <div v-if="nextTask" class="use-time-line">
          <strong>Next Scheduled Contact:</strong> {{ nextTask }}
          <b-button
            type="is-primary"
            size="is-small"
            outlined
            @click="setTimeToThis(nextTask)"
          >Use
          </b-button>
        </div>
      </div>
    </section>

    <footer class="modal-card-foot">
      <div class="mr-auto">
        <button-link color="is-danger" @click="cancel">
          Cancel
        </button-link>
      </div>

      <button-default @click="addDate">
        Add Required Date
      </button-default>
    </footer>
  </div>
</template>

<script>
import dates from "../../../services/dates";

export default {
  name: "RecordRequiredDateModal",
  props: {
    status: {
      type: Object,
      required: true
    },
    record: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      datetime: dates.getTomorrowJSDate(13,0),
    }
  },
  computed: {
    nextTask() {
      const tasks = this.$store.getters.pipelineIncompleteTasks.filter(a => a.record_id === this.record.id)
        .sort((a, b) => new Date(a.due_at) - new Date(b.due_at));

      if (tasks.length) {
        return dates.formatAsDate(tasks[0].due_at);
      }

      return null;
    },
    nextAppointment() {
      const appointments = this.$store.getters.pipelineAppointments.filter(a => a.record_id === this.record.id)
        .sort((a, b) => new Date(a.start_at) - new Date(b.start_at));

      if (appointments.length) {
        return dates.formatAsDate(appointments[0].start_at);
      }

      return null;
    },
  },
  methods: {
    addDate() {
      this.$emit('requiredDateSet', this.datetime);
      this.$parent.close();
    },
    cancel() {
      this.$emit('cancel');
      this.$parent.close();
    },
    setTimeToThis(date) {
      this.$emit('requiredDateSet', date);
      this.$parent.close();
    }
  }
}
</script>


<style lang="scss" scoped>
@import "../../../styles/variables/mixins";
@import "../../../styles/variables/variables";

.use-time-line {
  @include clearfix;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid $border;
  line-height: 27px;

  &:last-child {
    border-bottom: none;
  }

  button {
    float: right;
  }
}
</style>
